<template>
  <CRow class="w-100 h-100 justify-content-center pageError countDown">
    <CCol sm="12" class="d-flex"></CCol>
    <div class="w-100 z-index-10 d-flex flex-column p-5">
      <div>
        <h1 class="text-uppercase mt-5 mb-3 text-white">GO LIVE</h1>
        <h1 class="text-uppercase mt-5 mb-3 text-white fontBig mb-2">{{days}} <span >Days</span></h1>
      </div>
      <img src="@/assets/imgs/planet.png" class="planet" alt="" />
    </div>
    </CCol>

  </CRow>
</template>

<script>
export default {
  name: 'CountDown',
  data() {
    return {
      days: 0,
      hours: 0 ,
      minutes: 0,
      seconds: 0,
      timeleft: null,
      end: "TIME UP!!"
    }
  },
  mounted() {
    this.count()
  },

  methods: {
    count() {
      var countDownDate = new Date("Sep 30, 2022 00:00:00").getTime();
      var now = new Date().getTime();
      this.timeleft = countDownDate - now;

      this.days = Math.floor(this.timeleft / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((this.timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((this.timeleft % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((this.timeleft % (1000 * 60)) / 1000);

    }
  },
}
</script>

<style lang="scss" scope>
.pageError {
  .container {
    max-width: 1280px;
    width: 100%;
    height: 70vh;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  &.countDown {
    min-height: 100vh;
    background: $secondary;


    .fontBig {
      font-size: 6rem;
    }
  }

  img {
    max-width: 60%;
    &.astro {
      animation: float 6s ease-in-out infinite;
      transform: translateX(60%) translateY(-200%);
    }
    &.planet {
      animation: floatPLanet 5s ease-in-out infinite;
      transform: translateX(50%) translateY(10%);
    }
    &.stars {
      transform: translateX(50%) translateY(50%);
    }
  }

  .z-index-10 {
    z-index: 50;
  }

  @keyframes float {
    0% {
      transform: translateX(50%) translateY(-200%);
    }
    50% {
      transform: translateX(50%) translateY(-205%);
    }
    100% {
      transform: translateX(50%) translateY(-200%);
    }
  }
  @keyframes floatPLanet {
    0% {
      transform: translateX(50%) translateY(2%);
    }
    50% {
      transform: translateX(50%) translateY(0%);
    }
    100% {
      transform: translateX(50%) translateY(2%);
    }
  }
}
</style>
